  define 'controller/ProductTraceabilityDataController', ['jquery', 'lib/kryptonite', 'bootstrap/modal'], ($) ->
    class ProductTraceabilityDataController

      constructor: (@$el) ->
        @_loadTraceAbilityData()

      _loadTraceAbilityData: () ->
        self = @
        ref = @$el.data("article-number")
        xhrFields:
          showLoadingIndicator: false
        $.kryptonite
          url: "/tracedata/#{ref}"
          success: (data) ->
            self.$el.closest('[data-controller-element=product-traceability-wrap]').show()
